import { Control } from './Control'
import type { AnswerProps } from './types'

function boundOf(bound: number | string | undefined): number | undefined {
  return typeof bound === 'number' ? bound : undefined
}

// NumberAnswer answers number and year. A year is a number with bounds a
// century apart, and giving it a picker of its own would be a hundred rows to
// scroll where a keypad takes four taps.
export function NumberAnswer({ question, value, onChange }: AnswerProps) {
  const min = boundOf(question.min)
  const max = boundOf(question.max)

  return (
    <Control>
      <input
        className="field__control"
        type="number"
        inputMode="numeric"
        aria-label={question.text}
        value={typeof value === 'number' ? String(value) : ''}
        {...(min === undefined ? {} : { min })}
        {...(max === undefined ? {} : { max })}
        onChange={(event) => {
          const typed = event.target.value.trim()

          onChange(typed === '' ? undefined : Number(typed))
        }}
      />
    </Control>
  )
}
